import { render, staticRenderFns } from "./EconomyMemory.vue?vue&type=template&id=0d734af4&"
import script from "./EconomyMemory.vue?vue&type=script&lang=js&"
export * from "./EconomyMemory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports